import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const deleteCart = (basketNo) => {
    return instance.post(apis.Cart.Delete, {

        basketDtos: basketNo

    });
}
// 获取购物车列表
const getCart = () => {
    return instance.get(apis.Cart.Get);
}
// 获取购物车数量 需要更改
const getCartNumber = () => {
    return instance.get(apis.Cart.GetNO);
}
// 购物车是否选中
const checked = (data) => {
    return instance.post(apis.Cart.Checked,data);
}

// 购物车是否全选
const allchecked = (data) => {
    return instance.post(apis.Cart.AllChecked + "?isChoose=" + data);
}
// 更改购物车数量
const updateCartNumber = (data) => {
    return instance.post(apis.Cart.UpdateNO, data);
}
// 购物车下单 type2
const payPost = (data) => {
    return instance.post(apis.Cart.PayCheckout, data);
}

// 购物车清空下架商品
const EmpltyDeleted = () => {
    return instance.post(apis.Cart.EmpltyDeleted);
}

const UpdateCart = (goods) => {
    let postData = {
        basketDtos: []
    };
    goods.map(v => {
        postData.basketDtos.push({
            basketNo: v.basketNo,
            quantity: v.quantity,
            isCheck: v.checked
        });
    });
    return instance.put(apis.Cart.Update, postData);
}
// 获取限购商品详情
const GetLimitGoodsDetail = (data) => {
    return instance.post(apis.Goods.GetLimitGoodsDetail,data)
}
// 清空失效商品
const CleanInvalidGoods = () => {
    return instance.post(apis.Cart.CleanInvalidGoods)
}
// // 用户能否下单 有待付款订单，无法下单
const IsCartActivity = () => {
    return instance.post(apis.Cart.CartActivity)
}


export default {
    getCart,
    getCartNumber,
    checked,
    allchecked,
    updateCartNumber,
    payPost,
    deleteCart,
    UpdateCart,
    EmpltyDeleted,
    GetLimitGoodsDetail,
    CleanInvalidGoods,
    IsCartActivity
}